export default __webpack_public_path__ + "static/favicon-bbb6af6f4ea30bb291a7ecda0147f0e3.png";